import "../pages.css";
import "../../App.css";
import "./Home.css";
import { PrimaryLink } from "../../components/Link/PrimaryLink";
import { Separator } from "../../components/Separator/Separator";
import { LinkSection } from "../../components/LinkSection/LinkSection";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="PageBody">
      <div className="HomeContainer">
        <div className="BodyLeft">
          <h1 className="PageHeader">Hello, I'm Joachim 👋</h1>
          <p className="PageSubHeader">Software Engineer & Tech Lead at MyMoney.</p>
          <p className="PageText">
            I'm passionate about building scalable, reliable backend systems, designing robust APIs, and optimizing performance.
            Currently, I'm a Tech Lead at <PrimaryLink url="https://mymoney.se" label="MyMoney" />,
            where I design and develop backend services that power customer-facing products like <PrimaryLink url="https://mymoney.se/pay" label="MyMoney Pay" />.
            <br />
            <br />
            I enjoy solving complex problems, and creating software that makes a real impact.
            While backend development is my
            main focus, I also have experience with front-end technologies,
            which helps me collaborate effectively across the stack.
            <br />
            <br />
            My toolkit includes Kotlin, Java, TypeScript, Spring Boot, PostgreSQL, MySQL, and modern development workflows with Docker, GitHub Actions, and Gradle.
            <br />
            <br />
            <Link className="Primary-link" to={"/about"}>
              About me
            </Link>
          </p>
        </div>
        <div className="BodyRight">
          <img
            src={require("../../images/me.jpg")}
            alt=""
            className="GreetingImage"
          />
        </div>
      </div>
      <LinkSection />
      <Separator />
    </div>
  );
}
